import React from "react";
import { InvoiceTemplatesList } from "./InvoiceTemplatesList";

export const InvoiceTemplatesPage: React.FC = () => <InvoiceTemplatesList />;
